const listOfImages = [
  " /images/ocean.jpg",
  " /images/aquarell.jpg",
  " /images/palms.jpg",
];

export default listOfImages;
